import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';
import TuckDirectionsComponent from 'src/components/TruckDirectionsComponent';

import TruckDirectionPresenter from './TruckDirectionPresenter';

const TruckDirections: FC = memo(() => {
  const query = new URLSearchParams(useLocation().search);

  const shiftIds = query.get('ids').split(',').map((id) => Number(id));
  const queryAction = query.get('action');
  const action: '積' | '降' | null = queryAction
    ? ['積', '降']
      .find((str) => str === queryAction) as '積' | '降'
    : null;

  return <TuckDirectionsComponent action={action} shiftIds={shiftIds} presenter={TruckDirectionPresenter} />;
});

export default TruckDirections;
